







































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import BibliographyRealInfoMagazine from '@/components/organisms/BibliographyRealInfoMagazine/BibliographyRealInfoMagazine.vue'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  collectionApi,
  defaultSimpleBibliographyReal,
  defaultSystemCode,
  ErrorMessage,
  ShelfTypeConversionInfo,
  SimpleBibliographyReal,
  SystemCode
} from '@/api'
import { AlertCodeAL300039, ReceiptPrintName, SearchType } from '@/types'
import { RegistrationInfoEditTable } from '@/components/organisms/RegistrationInfoEditTable'
import { RegistrationInfoEditTableItem } from '@/components/organisms/RegistrationInfoEditTable/RegistrationInfoEditTable.vue'
import {
  alertStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import CODE_KEY from '@/config/code_key'
import { BibliographyRealInfoSimple } from '@/components/organisms/BibliographyRealInfoSimple'
import { ReceiptReserve } from '@/api/models/receipt/ReceiptReserve'
import { CommandType } from '@/types/websocket'

export interface ModalRegistrationInfoEditInterface {
  bibliographyRealId: number
  registrationItems: RegistrationInfoEditTableItem[]
  onRegistered: (firstElementCollectionNo: string) => void
}

@Component({
  components: {
    BibliographyRealInfoSimple,
    RegistrationInfoEditTable,
    BibliographyRealInfoMagazine,
    ModalFooter
  }
})
export default class ModalRegistrationInfoEdit extends ModalComponentBaseVue {
  bibliographyRealId: number = 0

  registrationItems: RegistrationInfoEditTableItem[] = []

  registeredCallback?: (firstElementCollectionNo: string) => void

  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  dialog: boolean = false

  tableBodyHeight: number = 0

  reserveAssignAlerts: Alert[] = []

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  @Watch('dialog')
  initialize(newVal: boolean): void {
    if (newVal) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.SHELF_TYPE.KEY])
      systemParameterStore
        .fetchAllAndMergeByCodeKeys([
          CODE_KEY.CALL_CONCATENATION_NUMBER_INSTRUCTION.KEY, // 請求記号表示に使用している
          CODE_KEY.NUMBER_MANAGEMENT.KEY, // 資料番号入力欄で使用している
          CODE_KEY.CALL_NUMBER_SETTING.KEY // 請求記号初期設定に使用する
        ])
        .then(() => {
          this.getSimpleBibliographyReal()
        })

      this.$nextTick(() => {
        window.addEventListener('resize', this.calculateTableHeight)
        this.calculateTableHeight()
      })
      return
    }

    window.removeEventListener('resize', this.calculateTableHeight)
    this.registrationItems = []
  }

  open(params: ModalRegistrationInfoEditInterface): void {
    this.bibliographyRealId = params.bibliographyRealId
    this.registrationItems = params.registrationItems
    this.registeredCallback = params.onRegistered
    this.dialog = true
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  close(): void {
    this.dialog = false
  }

  print(): void {
    const element = document.getElementById('modal-registration-info-edit')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  setErrorMessage(alerts: Alert[]): void {
    alerts.some(alert => {
      if (alert.index === -1 || alert.subAttribute === '') return false
      switch (alert.subAttribute) {
        case 'id':
          this.registrationItems[alert.index].id.errorMessage = alert.message
          break
        case 'holding_branch_code':
          this.registrationItems[alert.index].holdingBranchCode.errorMessage =
            alert.message
          break
        case 'shelf_type':
          this.registrationItems[alert.index].shelfType.errorMessage =
            alert.message
          break
        case 'collection_type':
          this.registrationItems[alert.index].collectionType.errorMessage =
            alert.message
          break
        case 'trader_code':
          this.registrationItems[alert.index].traderCode.errorMessage =
            alert.message
          break
        case 'donor_code':
          this.registrationItems[alert.index].donorCode.errorMessage =
            alert.message
          break
        case 'accept_date':
          this.registrationItems[alert.index].acceptOrderDate.errorMessage =
            alert.message
          break
        case 'accept_price':
          this.registrationItems[alert.index].acceptOrderPrice.errorMessage =
            alert.message
          break
        case 'accept_type':
          this.registrationItems[alert.index].acceptType.errorMessage =
            alert.message
          break
        case 'appendix_code':
          this.registrationItems[alert.index].appendixCode.errorMessage =
            alert.message
          break
      }
    })
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        this.bibliographyRealId
      )

      if (systemParameterStore.isSetCallNumberOnRegistration) {
        this.registrationItems.forEach(item => {
          item.ndc = this.simpleBibliographyReal.displayClass
        })
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async registrationCollections(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const receiptReserve: ReceiptReserve[] = await bibliographyRealApi.registrationCollections(
        this.bibliographyRealId,
        {
          collections: this.registrationItems.map(item => {
            return {
              collectionNo: item.id.input,
              holdingBranchCode: item.holdingBranchCode.input,
              buyDepartmentCode: item.buyDepartmentCode,
              mark: item.mark,
              ndc: item.ndc,
              book: item.book,
              sub: item.sub,
              shelfType: item.shelfType.input,
              collectionType: item.collectionType.input,
              handlingType: item.handlingType.input,
              traderCode: item.traderCode.input,
              donorCode: item.donorCode.input,
              acceptDate: item.acceptOrderDate.input,
              acceptPrice: Number(item.acceptOrderPrice.input),
              acceptType: item.acceptType.input,
              appendixCode: item.appendixCode.input,
              equipType: item.equipType,
              budgetYear: item.budgetYear,
              budgetBranchCode: item.budgetBranchCode,
              budgetDepartmentCode: item.budgetDepartmentCode,
              budgetExpenseCode: item.budgetExpenseCode,
              _reserveAssign: item._reserveAssign
            }
          })
        }
      )

      receiptReserve.forEach(item => {
        if (item.receiptInfoReserve !== undefined) {
          this.$webSocket.sendReceiptPrintMessage({
            command: CommandType.ReceiptPrintReserve,
            name: ReceiptPrintName.ReceiptPrintReserve,
            data: item.receiptInfoReserve,
            subject: `利用者番号：${item.receiptInfoReserve.user_id}`
          })
        }
        if (item.receiptInfoReserveForwarding !== undefined) {
          this.$webSocket.sendReceiptPrintMessage({
            command: CommandType.ReceiptPrintReserveForwarding,
            name: ReceiptPrintName.ReceiptPrintReserveForwarding,
            data: item.receiptInfoReserveForwarding,
            subject: `資料番号：${item.receiptInfoReserveForwarding.collection_no}`
          })
        }
      })

      if (this.registeredCallback) {
        this.registeredCallback(this.registrationItems[0].id.input)
      }
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        error.alerts.forEach(alert => {
          if (alert.code === AlertCodeAL300039) {
            this.reserveAssignAlerts.push(alert)
          }
        })

        if (this.reserveAssignAlerts.length === 0) {
          this.setErrorMessage(error.alerts)
          alertStore.setItems(error.alerts)
          this.$modalAlert.open()
        } else {
          this.reserveAssignConfirm()
        }
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  reserveAssignConfirm() {
    if (this.reserveAssignAlerts.length === 0) {
      this.registrationCollections()
      return
    }

    const alert = this.reserveAssignAlerts.shift()
    if (alert === undefined) return

    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.setReserveAssign(alert.attribute, true)
        setTimeout(() => this.reserveAssignConfirm(), 100)
      },
      onCancelClick: () => {
        this.setReserveAssign(alert.attribute, false)
        setTimeout(() => this.reserveAssignConfirm(), 100)
      }
    })
  }

  setReserveAssign(collectionNo: string, result: boolean) {
    const item = this.registrationItems.find(
      item => item.id.input === collectionNo
    )
    if (item === undefined) return
    item._reserveAssign = result
  }

  async convertShelfType(index: number): Promise<void> {
    if (
      this.registrationItems[index].collectionType.input === '' &&
      this.registrationItems[index].mark === '' &&
      this.registrationItems[index].ndc === '' &&
      this.registrationItems[index].book === '' &&
      this.registrationItems[index].sub === ''
    ) {
      return
    }

    this.$eventBus.emit(NAV_LOADING_START)

    try {
      const response: ShelfTypeConversionInfo = await collectionApi.getShelfTypeConversionInfo(
        {
          collectionType: this.registrationItems[index].collectionType.input,
          mark: this.registrationItems[index].mark,
          ndc: this.registrationItems[index].ndc,
          book: this.registrationItems[index].book,
          sub: this.registrationItems[index].sub
        }
      )
      const systemCode: SystemCode =
        systemCodeStore.findByCodeKeyAndCode(
          CODE_KEY.SHELF_TYPE.KEY,
          response.shelfType
        ) ?? defaultSystemCode()

      this.registrationItems[index].shelfType.input = systemCode.code
      this.registrationItems[index].shelfType.shortName = systemCode.shortName
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }
}
